import { render, staticRenderFns } from "./modalReset.vue?vue&type=template&id=0bf2345c"
import script from "./modalReset.vue?vue&type=script&lang=js"
export * from "./modalReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports